<template>
  <div 
    class="name-avatar"
    :style="{
      backgroundColor: backgroundColor,
      color: textColor,
      width: size + 'px',
      height: size + 'px',
      lineHeight: size + 'px',
      fontSize: fontSize + 'px'
    }"
  >
    {{ initials }}
  </div>
</template>

<script>
export default {
  name: 'NameAvatar',
  props: {
    fullName: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 40
    },
    customColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    initials() {
      if (!this.fullName) return '';
      
      const names = this.fullName.split(' ').filter(n => n.length > 0);
      
      if (names.length === 0) return '';
      if (names.length === 1) return names[0].charAt(0).toUpperCase();
      
      return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    },
    backgroundColor() {
      if (this.customColor) return this.customColor;
      
      const hash = this.fullName.split('').reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
      }, 0);
      
      const h = Math.abs(hash % 360);
      const s = '70%';
      const l = '60%';
      
      return `hsl(${h}, ${s}, ${l})`;
    },
    textColor() {
      return '#ffffff';
    },
    fontSize() {
      return Math.floor(this.size * 0.4);
    }
  }
}
</script>

<style scoped>
.name-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  text-align: center;
  user-select: none;
}
</style>